import React from 'react';
import { I18n } from '@fiverr-private/fiverr_context';
import { NumberOfResultsTypes } from '../../../types';
import PromotedAdsInfoIcon from './PromotedAdsInfoIcon';
import './index.scss';

const TRANSLATION_KEY_POSTFIX = { WITH_ADS: 'results_with_ads', DEFAULT: 'results' };

const NumberOfResults = ({ pagination: { total } = {}, withAds = false }) => {
    const translationKeyPostfix = withAds ? TRANSLATION_KEY_POSTFIX.WITH_ADS : TRANSLATION_KEY_POSTFIX.DEFAULT;

    return (
        <div className="number-of-results">
            <span className="m-r-4"><I18n k={`search_perseus.number_of_results.${translationKeyPostfix}`} params={{ total: total && total.toLocaleString() }}/></span>
            {withAds && <PromotedAdsInfoIcon/>}
        </div>
    );

};

NumberOfResults.propTypes = NumberOfResultsTypes;

export default NumberOfResults;
